// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import SingleProductTemplate from "../templates/SingleProductTemplate/SingleProductTemplate";
const __wvcRoutePaths = ["/post/product/:post_id"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "cart", "cartpage", "checkout", "checkoutpage", "contact", "contactpage", "home", "homepage", "my-account", "myaccountpage", "post", "privacy-policy", "privacypage", "returns-refunds", "returnspage", "search", "shipping-policy", "shippingpage", "shop", "shoppage", "term", "terms-of-service", "termspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<SingleProductTemplate />} />
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
